
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companySlug]/articles/[articleSlug]",
      function () {
        return require("private-next-pages/[companySlug]/articles/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companySlug]/articles/[articleSlug]"])
      });
    }
  